import * as React from "react";
import { Column, Columns, Stack } from "@origin-digital/ods-core";
import { IArticle } from "../../../../shared/interface/article";
import { ArticleBody } from "./ArticleBody";

interface IProps {
  article: IArticle;
}

export const ArticleBodyController = ({ article }: IProps) => {
  return (
    <Columns collapseBelow="md" space="xlarge">
      <Column width="2/3">
        <Stack space="large">
          <ArticleBody title={article.title} body={article.body} />
        </Stack>
      </Column>
      <Column>
        <></>
      </Column>
    </Columns>
  );
};
